module.exports = __webpack_public_path__ + "assets/img/logo.1eb6849.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 1